// extracted by mini-css-extract-plugin
export default {"Ports":"Ports_Ports__t8fYj","Ports__new":"Ports_Ports__new__X6rgZ","Ports__table":"Ports_Ports__table__vOo+s"};